/**
 * lgk-outil-detail.js — Page outil individuelle avec widget intégré
 */
(function () {
  'use strict';

  const urls = window.LGK_OUTILS_URLS || {
    shopRoot(mainUrl) {
      const base = (mainUrl || '/pages/outils').replace(/\/+$/, '');
      return base.replace(/\/pages\/outils$/, '') || '';
    },
    toolPageUrl(mainUrl, toolId) {
      const root = this.shopRoot(mainUrl);
      return `${root}/pages/outil-${toolId}`;
    },
    guideUrl(mainUrl, toolId) {
      const root = this.shopRoot(mainUrl);
      return `${root}/blogs/outils-gratuits/guide-${toolId}`;
    },
  };

  function getCatalog() {
    return window.LGK_OUTILS_CATALOG || { tools: [] };
  }

  function findTool(id) {
    return getCatalog().tools?.find((t) => t.id === id);
  }

  function renderHubLinks(hub, mainUrl) {
    return (hub.links || [])
      .map((link) => {
        const isInternal = link.url?.startsWith('#');
        const href = isInternal
          ? urls.toolPageUrl(mainUrl, link.url.slice(1))
          : link.url || '#';
        const external = !isInternal && /^https?:\/\//i.test(link.url || '');
        return `
          <a class="lgk-outils-hub__hub-link" href="${href}" role="listitem"
            ${external ? ' target="_blank" rel="noopener noreferrer"' : ''}>
            <span class="lgk-outils-hub__hub-link-icon" aria-hidden="true">${link.icon || '🔗'}</span>
            <span class="lgk-outils-hub__hub-link-body">
              <span class="lgk-outils-hub__hub-link-title">${link.title}</span>
              <span class="lgk-outils-hub__hub-link-desc">${link.desc || ''}</span>
            </span>
            ${link.badge ? `<span class="lgk-outils-hub__hub-link-badge">${link.badge}</span>` : ''}
          </a>`;
      })
      .join('');
  }

  function init(page) {
    const toolId = page.dataset.toolId;
    const mainUrl = page.dataset.mainUrl || '/pages/outils';
    const modal = page.querySelector('[id^="lgk-outil-modal-"]');
    const panel = modal?.querySelector('[data-tool-panel]');
    const modalTitle = modal?.querySelector('[data-modal-title]');
    const widget = page.querySelector('[data-tool-widget]');
    const openBtn = page.querySelector('[data-open-tool]');
    const tools = window.LGK_OUTILS_TOOLS || {};
    const item = findTool(toolId);

    if (!item) {
      if (widget) {
        widget.hidden = false;
        widget.innerHTML = `<p class="lgk-outil-detail__error">Outil introuvable. <a href="${mainUrl}">Retour au hub</a></p>`;
      }
      return;
    }

    function openExternal(url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }

    function openAppInModal(id) {
      const tool = tools[id];
      if (!tool || !panel) return false;
      modalTitle.textContent = findTool(id)?.title || item.title;
      panel.innerHTML = tool.render();
      if (tool.mount) tool.mount(panel);
      modal?.showModal?.();
      return true;
    }

    function openHubInModal() {
      const hub = getCatalog().hubs?.[toolId];
      if (!hub || !panel) return;
      modalTitle.textContent = item.title;
      panel.innerHTML = `
        <p class="lgk-outil__hint">${hub.intro || ''}</p>
        <div class="lgk-outils-hub__hub-links" role="list">
          ${renderHubLinks(hub, mainUrl)}
        </div>`;
      modal?.showModal?.();
    }

    function renderHubInline() {
      const hub = getCatalog().hubs?.[toolId];
      if (!hub || !widget) return false;
      widget.hidden = false;
      const gdHref = item.gdUrl || '';
      widget.innerHTML = `
        <div class="lgk-outil-detail__inline lgk-outil-detail__hub">
          <p class="lgk-outil__hint">${hub.intro || ''}</p>
          <div class="lgk-outils-hub__hub-links" role="list">
            ${renderHubLinks(hub, mainUrl)}
          </div>
          ${gdHref ? `<p class="lgk-outil-detail__gd-link"><a href="${gdHref}" target="_blank" rel="noopener noreferrer">Voir la version GothamDev →</a></p>` : ''}
        </div>`;
      return true;
    }

    function renderLinkInline() {
      if (!item.url || !widget) return false;
      widget.hidden = false;
      const host = item.url.replace(/^https?:\/\//, '').split('/')[0];
      widget.innerHTML = `
        <div class="lgk-outil-detail__inline lgk-outil-detail__external">
          <p>Cet outil est hébergé sur <strong>${host}</strong>.</p>
          <a class="lgk-outil-detail__cta" href="${item.url}" target="_blank" rel="noopener noreferrer">Ouvrir l'outil →</a>
        </div>`;
      return true;
    }

    function runTool() {
      if (item.type === 'link' && item.url) {
        openExternal(item.url);
        return;
      }
      if (item.type === 'hub') {
        openHubInModal();
        return;
      }
      if (openAppInModal(toolId)) return;
      if (item.url) openExternal(item.url);
    }

    if (openBtn) {
      if (item.type === 'link') {
        openBtn.textContent = "Ouvrir l'outil externe";
      }
      openBtn.addEventListener('click', runTool);
    }

    if (item.type === 'app' && tools[toolId] && widget) {
      widget.hidden = false;
      const tool = tools[toolId];
      widget.innerHTML = '';
      const wrap = document.createElement('div');
      wrap.className = 'lgk-outil-detail__inline';
      wrap.innerHTML = tool.render();
      widget.appendChild(wrap);
      if (tool.mount) tool.mount(wrap);
    } else if (item.type === 'hub') {
      renderHubInline();
    } else if (item.type === 'link') {
      widget.hidden = true;
    } else if (widget) {
      widget.hidden = true;
    }

    modal?.querySelector('[data-modal-close]')?.addEventListener('click', () => modal.close());
    modal?.addEventListener('click', (e) => {
      if (e.target === modal) modal.close();
    });

    if (location.hash === '#utiliser') runTool();
  }

  function boot() {
    document.querySelectorAll('[data-lgk-outil-page]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
